import {Injectable, OnDestroy} from '@angular/core';
import {Store} from '@ngrx/store';
import {Map} from 'immutable';
import {EntityIndicador} from 'src/app/ngrx/entitys/entity-indicador/entity-indicador.model';
import {upsertEntityIndicadores} from '~entity/entity-indicador/entity-indicador.actions';
import {IndicadoresAPIService} from '../api/indicadores.api.service';
import {compare} from '~utils/list-utils';

@Injectable({providedIn: 'root'})
export class IndicadoresService {

  indicadoresPadrao: EntityIndicador[] = [
    {
      id: 'atraso',
      titulo: 'Atraso',
      valorMinimo: 30,
      valorMaximo: 90,
      reverso: false,
      exibir: true,
    },
    {
      id: 'distancia',
      titulo: 'Distância',
      valorMinimo: 30,
      valorMaximo: 90,
      reverso: false,
      exibir: true,
    },
    {
      id: 'ocupacao',
      titulo: 'Ocupação',
      valorMinimo: 30,
      valorMaximo: 90,
      reverso: false,
      exibir: true,
    },
    {
      id: 'pedidos',
      titulo: 'Pedidos',
      valorMinimo: 30,
      valorMaximo: 80,
      reverso: true,
      exibir: true,
      exibirPercentuais: true,
    },
    {
      id: 'rotas',
      titulo: 'Rotas',
      valorMinimo: 30,
      valorMaximo: 80,
      reverso: false,
      exibir: true,
    },
    {
      id: 'veiculos',
      titulo: 'Veículos',
      valorMinimo: 30,
      valorMaximo: 80,
      reverso: false,
      exibir: false,
    },
    {
      id: 'visitas',
      titulo: 'Visitas',
      valorMinimo: 30,
      valorMaximo: 80,
      reverso: true,
      exibir: true,
    },
  ];

  constructor(
    private store: Store,
    private indicadoresAPIService: IndicadoresAPIService
  ) {
  }

  inicializar(): void {
    this.indicadoresAPIService.getIndicadores().subscribe(res => {
      const entities = Map(res.indicadores).toArray().map(([_, indicador]) => (indicador));

      for (const indicador of this.indicadoresPadrao) {
        if (entities.findIndex(i => i.id === indicador.id) < 0) {
          entities.push(indicador);
          this.indicadoresAPIService.addIndicador(indicador).subscribe();
        }
      }

      entities.sort((a: EntityIndicador, b: EntityIndicador) => compare(a.titulo, b.titulo));

      this.store.dispatch(upsertEntityIndicadores({entities}) as any);
    });
  }
}
